import axios from "axios";

const AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api",
  timeout: 10000, // 10 seconds timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add response interceptor for better error handling
AxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
      console.error('Network Error: Unable to connect to server');
      error.message = 'Unable to connect to server. Please check if the server is running.';
    }
    return Promise.reject(error);
  }
);

export default AxiosInstance;
